import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Style/ContactSection.css';
import contactData from '../../Json/ContactSectionData.json';

const ContactSection = () => {
  const navigate = useNavigate();

  // ✅ OPEN ANIMATION
  useEffect(() => {
    const section = document.querySelector(".contact-section-wrapper");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="contact-section-wrapper">
      <div className="contact-card-main">
        <h2>{contactData.title}</h2>

        <p>{contactData.description}</p>

        <button
          className="contact-cta-button"
          onClick={() => navigate('/contact')}
        >
          {contactData.buttonText}
        </button>
      </div>
    </section>
  );
};

export default ContactSection;